import { API_ENDPOINTS, DOMAINS } from "../common/constants";

const getEnvironmentSuffix = (hostname) => {
  if (hostname) {
    if (hostname.includes(DOMAINS.DEV)) {
      return "-dev";
    } else if (hostname.includes(DOMAINS.STAGE)) {
      return "-stage";
    }
  }

  return "";
};

/**
 * Returns the root cookie domain for a given hostname, stripping any subdomain
 * so that cookies are always scoped to the shared root domain (e.g.
 * `storefront.homedepot.com` → `.homedepot.com`). This prevents duplicate
 * cookies being created on subdomain-specific scopes.
 */
const getRootDomain = (hostname) => {
  if (!hostname) return "";
  try {
    const knownDomains = [DOMAINS.DEV, DOMAINS.STAGE, DOMAINS.PROD];
    for (const domain of knownDomains) {
      if (hostname.endsWith(domain)) {
        return `.${domain}`;
      }
    }
    return `.${hostname.replace("www.", "")}`;
  } catch {
    return `.${hostname.replace("www.", "")}`;
  }
};

const getApiHost = (hostname) => {
  if (!hostname) return "";
  return `//${hostname}`;
};

/**
 * Returns the canonical host for API service calls (StoreSearchServices,
 * LocationService, etc.). In production, these services only run on
 * www.homedepot.com, so any non-www subdomain (e.g. videos.homedepot.com)
 * must route API requests to //www.homedepot.com rather than the current host.
 */
const getCanonicalHost = (hostname) => {
  if (!hostname) return "";
  if (hostname.includes(DOMAINS.DEV)) {
    return `//${DOMAINS.DEV}`;
  }
  if (hostname.includes(DOMAINS.STAGE)) {
    return `//${DOMAINS.STAGE}`;
  }
  if (hostname.endsWith(DOMAINS.PROD)) {
    return `//www.${DOMAINS.PROD}`;
  }
  return `//${hostname}`;
};

export const getConfig = () => {
  const hostname =
    typeof window !== "undefined" ? window?.location?.hostname : "";
  const localizationApiSuffix = getEnvironmentSuffix(hostname);

  return {
    domain: getRootDomain(hostname),
    host: getApiHost(hostname),
    canonicalHost: getCanonicalHost(hostname),
    localizationApiHost: `//localization${localizationApiSuffix}.thdws.com`,
    service: API_ENDPOINTS.LOCALIZATION_SERVICE,
    storeSearchService: API_ENDPOINTS.STORE_SEARCH_SERVICE,
    locationService: API_ENDPOINTS.LOCATION_SERVICE,
  };
};
